'use client'

import { IconLockColor } from '@macarongfactory/web-icons'
import { SolidButton, Text } from '@macarongfactory/web-ui'

import type { Ref } from 'react'

interface ILockOverlayProps {
  /** 잠금 문구 — 배열이면 줄마다 끊어 노출 (Figma 줄바꿈 '/' 위치) */
  message: string | string[]
  /** CTA 버튼 문구 */
  buttonText: string
  /** CTA 버튼 variant — 실연비 게이지 neutral / 추이 brand (Figma) */
  buttonVariant: 'neutral' | 'brand'
  onClick: () => void
  /** 위치 지정 클래스 (기본 inset-0 — 부모 relative 기준 전체 덮기) */
  className?: string
  /** 노출(show) 트래킹용 ref */
  impressionRef?: Ref<HTMLDivElement>
}

/** 자물쇠 아이콘 크기(px) — Figma Multicolor/ic_lock_color 24 */
const LOCK_ICON_SIZE_PX = 24

/**
 * 잠금 프레임 (설치율 A/B 잠금 화면 B) — 흐림 처리한 영역 위에 겹쳐 앱 이동을 유도한다.
 * Figma 'lock overlay' (10259:25947 실연비 게이지 / 10259:26035 추이):
 * 흰색 50% 배경 · 세로 gap 8 · 좌우 16 · 자물쇠 24 · Title2 Bold 15 neutral-normal · Solid Button M
 */
const LockOverlay = ({
  message,
  buttonText,
  buttonVariant,
  onClick,
  className = 'inset-0',
  impressionRef,
}: ILockOverlayProps) => {
  const lines = Array.isArray(message) ? message : [message]

  return (
    <div
      ref={impressionRef}
      className={`absolute flex flex-col items-center justify-center gap-dimension-x2 overflow-clip bg-[rgba(255,255,255,0.5)] px-dimension-x4 ${className}`}
    >
      <IconLockColor
        width={LOCK_ICON_SIZE_PX}
        height={LOCK_ICON_SIZE_PX}
        aria-hidden
      />
      <Text
        variant='title-2-bold'
        color='text-foreground-neutral-normal'
        className='text-center'
      >
        {lines.map(line => (
          <span key={line} className='block'>
            {line}
          </span>
        ))}
      </Text>
      <SolidButton
        text={buttonText}
        variant={buttonVariant}
        size='medium'
        clickable={onClick}
      />
    </div>
  )
}

export default LockOverlay
